/** Canonical list of product attribution attribute keys used across catalog enrichment flows. */
export const attributes = [
  'title',
  'structuredTitle',
  'shortTitle',
  'description',
  'structuredDescription',
  'productHighlight',
  'productDetail',
  'productType',
  'color',
  'material',
  'pattern',
  'multipack',
  'isBundle',
  'googleProductCategory',
  'productLength',
  'productWidth',
  'productHeight',
  'productWeight',
  'questionAndAnswer',
  'documentLink',
  'relatedProduct',
  'itemGroupTitle',
  'variantOption',
  'popularityRank',
] as const;

/** Union type of all valid attribution attribute keys. */
export type AttributeKey = (typeof attributes)[number];
